export const ModuleContext = 'context';
export const ModuleOption = 'option';
export const ModuleEmployee = 'employee';
export const ModuleLayout = 'layout';
export const ModuleOrganizationUnit = 'organizationUnit';
export const ModuleInventoryItem = 'inventoryItem';
export const ModuleAccount = 'account';
export const ModuleBuPlanWithDraw = 'buPlanWithDraw';
export const ModuleStock = 'stock';
export const ModuleDictionaryChapter = 'dictionaryChapter';
export const ModuleDictionaryRegular = 'dictionaryRegular';
export const ModuleDictionaryRegularPopup = 'dictionaryRegularPopup';
export const ModuleDictionaryRegularExplanation = 'dictionaryRegularExplanation';
export const ModuleDictionarySource = 'dictionarySource';
export const ModuleDictionaryKind = 'dictionaryKind';
export const ModuleProject = 'project';
export const DemoTreeModule = 'demoTree';
export const ModuleExpenseInvest = 'expenseInvest';
export const ModuleRevenueOther = 'revenueOther';
export const ModuleDictionaryBusiness = 'DictionaryBusiness';
export const ModuleDictionaryFees = 'dictionaryFees';
export const ModuleDictionaryPresent = 'dictionaryPresent';
export const ModuleReportTemplateFile = 'reportTemplateFile';
export const ModuleReportCollection = 'budgetCollection';
export const ModuleBudgetItem = 'budgetItem';
export const ModuleDictionarySection = 'dictionarySection';
export const ModuleDictionaryPatternRegular = 'dictionaryPatternRegular';
export const ModuleDictionaryPatternRegularTemplate = 'dictionaryPatternRegularTemplate';
export const ModuleDictionaryPatternRegularSubItem = 'dictionaryPatternRegularSubItem';
export const ModuleDictionaryField = 'dictionaryField';
export const ModuleEstimateRevenueFees = 'estimateRevenueFee';
export const ModuleEstimateExpenseFees = 'estimateExpenseFee';
export const ModuleBusinessSetting = 'businessSetting';
export const ModuleCalculationBasis = 'calculationBasis';
export const ModuleStorageTemplateExplanationList = 'storageTemplateExplanationList';
export const ModuleLayoutSalary = 'layoutsalary';
export const ModuleDictionaryStaff = 'dictionaryStaff';
export const ModuleCeilingExpensePublish = 'ceilingExpensePublish'; // danh mục trần chi
export const ModuleAuditEstimateListThreeYear = 'auditEstimateListThreeYear'; // danh mục trần chi

//ban hành
export const ModuleEnactDictionary = 'enactDictionary';
export const ModuleDeleteEnact = 'deleteEnact';
export const ModulePublishEnact = 'publishEnact';
export const ModuleEnactDictionaryHistory = 'enactDictionaryHistory';
export const ModuleRevenueBudgetEnact = 'revenueBudgetEnact';
export const ModuleAddRevenueBudgetEnact = 'addRevenueBudgetEnact';
export const ModuleAddCriteriaEnactStore = 'addCriteriaEnactStore';
export const ModuleRevenueOtherEnact = 'revenueOtherEnact';
export const ModuleAddRevenueOtherEnact = 'addRevenueOtherEnact';
export const ModuleExpenseOtherEnact = 'expenseOtherEnact';
export const ModuleAddExpenseOtherEnact = 'addExpenseOtherEnact';
export const ModuleRevenueBusinessEnact = 'revenueBusinessEnact';
export const ModuleAddRevenueBusinessEnact = 'addRevenueBusinessEnact';
export const ModuleEnactContent = 'enactContent';
export const ModulePatternEstimateExpenseRegularEnact = 'patternEstimateExpenseRegularEnact';
export const ModuleExpenseProjectEnact = 'expenseProjectEnact';
export const ModuleAddExpenseProjectEnact = 'addExpenseProjectEnact';
export const ModuleExpenseRegularEnact = 'expenseRegularEnact';
export const ModuleAddExpenseRegularEnact = 'addExpenseRegularEnact';
export const ModuleExpenseInvestEnact = 'expenseInvestEnact';
export const ModuleAddExpenseInvestEnact = 'addExpenseInvestEnact';
export const ModuleRevenueFeeEnact = 'moduleRevenueFeeEnact';
export const ModuleAddRevenueFeeEnact = 'addRevenueFeeEnact';
export const ModuleExplanationFormEnact = 'explanationFormEnact';
export const ModuleAddExplanationFormEnact = 'addExplanationFormEnact';
export const ModuleCalculationBasisEnact = 'calculationBasisEnact';
export const ModuleAddCalculationBasisEnact = 'addCalculationBasisEnact';
export const ModuleAddCalculationBasisEnactByKind = 'addCalculationBasisEnactByKind';
export const ModuleCriteriaEnact = 'criteriaEnact';
export const ModuleAddCriteriaEnact = 'addCriteriaEnact';
export const ModuleEstimateRevenueOther = 'estimateRevenueOther';
export const ModuleEstimateRevenueBusiness = 'estimateRevenueBusiness';
export const ModuleEstimateArrgrateThreeYear = 'estimateArrgrateThreeYear';
export const ModuleEstimateThreeYearRevenueBusiness = 'estimateThreeYearRevenueBusiness';
export const ModuleEstimateArrgrateThreeYearRevenueBusiness = 'estimateArrgrateThreeYearRevenueBusiness';
export const ModuleEstimateArrgrateThreeYearExpenseBusiness = 'estimateArrgrateThreeYearExpenseBusiness';
export const ModuleEstimateArrgrateThreeYearRevenueFees = 'estimateArrgrateThreeYearRevenueFees';
export const ModuleEstimateArrgrateThreeYearExpenseFees = 'estimateArrgrateThreeYearExpenseFees';
export const ModuleEstimateThreeYearBusiness = 'estimateThreeYearBusiness';
export const ModuleEstimateExpenseBusiness = 'estimateExpenseBusiness';
export const ModuleEstimateStorageExplanation = 'dictionaryEnact';
export const ModuleChooseOrgEnact = 'chooseOrgEnact';
export const ModuleEstimateThreeYearExpenseBusiness = 'estimateThreeYearExpenseBusiness';
export const ModuleEstimateFinanceThreeYearRevenueOther = 'estimateFinanceThreeYearRevenueOther';
export const ModuleEstimateFinanceThreeYearExpenseOther = 'estimateFinanceThreeYearExpenseOther';
export const ModuleEstimateFinanceThreeYearProject = 'estimateFinanceThreeYearProjectExpense';
export const ModuleEstimateFinanceThreeYearBudgetCollection = 'estimateFinanceThreeYearBudgetCollection';
export const ModuleEstimateFinanceThreeYearExpenseInvest = 'estimateFinanceThreeYearExpenseInvest';

//Đồng bộ danh mục
export const ModuleSyncDictionaryInvest = 'syncDictionaryInvest';
export const ModuleSyncDictionaryProject = 'syncDictionaryProject';
export const ModuleSyncDictionaryRegular = 'syncDictionaryRegular';
export const ModuleSyncDictionaryBudget = 'syncDictionaryBudget';
export const ModuleSyncDictionaryCriteria = 'syncDictionaryCriteria';
export const ModuleSyncDictionaryExpenseOther = 'syncDictionaryExpenseOther';
export const ModuleSyncDictionaryExplanation = 'syncDictionaryExplanation';
export const ModuleSyncDictionaryCalculationBasis = 'syncDictionaryCalculationBasis';
export const ModuleSyncDictionaryPatternRegular = 'syncDictionaryPatternRegular';
export const ModuleResultSyncDictionary = 'resultSyncDictionary';
export const ModuleSyncDictionaryFees = 'syncDictionaryFees';
export const ModuleSyncDictionaryRevenueBusiness = 'syncDictionaryRevenueBusiness';
export const ModuleSyncDictionaryRevenueOther = 'syncDictionaryRevenueOther';
export const ModuleSyncDictionary = 'syncDictionary';

// Lấy trường thuyết minh
export const ModuleExplanationForm = 'ExplanationForm';
export const ModuleExplanationFormModel = 'ExplanationFormModel';
export const ModuleExplanationFormModelListType = 'ExplanationFormModelListType';

export const ModulePublicReportCustom = 'PublicReportCustom';
export const ModuleReportCustom = 'ReportCustom';
export const ModuleReportCustomPrint = 'ReportCustomPrint';
export const ModuleExplanationFormView = 'ExplanationFormView';
export const ModuleExplanatoryReport = 'ExplanatoryReport';
export const ModuleReportSummary = 'ReportSummary';
export const ModuleReportFile = 'ReportFile';

export const ModuleEstimateExplanationForm = 'EstimateExplanationForm';
export const ModuleEstimateExplanationFormSalary = 'EstimateExplanationFormSalary';
export const ModuleSubmitEstimateExplanationFormSalaryStc = 'SubmitEstimateExplanationFormSalaryStc';
export const ModuleSubmitArrgrateExplanationFormStc = 'SubmitArrgrateExplanationFormStc';
export const ModuleEstInitialExplanationFormSalary = 'EstInitialExplanationFormSalary';
export const ModuleSubmitEstimateExplanationFormSalary = 'SubmitEstimateExplanationFormSalary';
export const ModuleSubmitEstimateSectorWideExplanationFormSalary = 'SubmitEstimateSectorWideExplanationFormSalary';
export const ModuleAuditReceiveArrgrateExplanationFormSalary = 'auditReceiveArrgrateExplanationFormSalary';
export const ModuleEstimateRegularExplanation = 'EstimateRegularExplanation';
export const ModuleEstimateExplanationFormModelListType = 'EstimateExplanationFormModelListType';

export const ModuleBudgetCollectionAgency = 'budgetCollectionAgency';

export const ModuleDictionaryRevenueAgency = 'dictionaryRevenueAgency';
export const ModuleDictionaryRevenueBudget = 'dictionaryRevenueBudget';
export const ModuleDictionaryRevenueBudgetWards = 'dictionaryRevenueBudgetWards';
export const ModuleDictionaryRevenueBudgetAgency = 'dictionaryRevenueBudgetAgency';
export const ModuleDictionaryRevenueBudgetRate = 'dictionaryRevenueBudgetRate';
export const ModuleDictionaryExpenseOther = 'dictionaryExpenseOther';

export const ModuleDbOption = 'dbOption';
export const CriteriaModule = 'criteria';
export const ModuleDatabase = 'database';
export const ModuleInfomation = 'infomationOrganization';
export const ModuleEstimateCategory = 'estimateCategory';
export const ModuleEstimateRegular = 'estimateRegular';
export const ModuleEstimateExpenseOther = 'estimateExpenseOther';
export const ModuleEstimateProject = 'estimateProject';
export const ModuleEstimateProjectSTC = 'estimateProjectSTC';
export const ModuleSubmitSectorWideExplanationForm = 'submitSectorWideExplanationForm';
export const ModuleSubmitSectorWideStorageExplanation = 'submitSectorWideStorageExplanation';
export const ModuleSubmitSectorWideCalculationBasis = 'submitSectorWideCalculationBasis';
export const ModuleSubmitSectorWideRevenueFee = 'submitSectorWideRevenueFee';
export const ModuleSubmitSectorWideExpenseProject = 'submitSectorWideExpenseProject';
export const ModuleSubmitSectorWideExpenseRegular = 'submitSectorWideExpenseRegular';
export const ModuleSubmitSectorWideExpenseInvest = 'submitSectorWideExpenseInvest';
export const ModuleSubmitSectorWideExpenseFee = 'submitSectorWideExpenseFee';
export const ModuleSubmitSectorWideExpenseBusiness = 'submitSectorWideExpenseBusiness';
export const ModuleSubmitArrgrateStorageExplanationStc = 'submitArrgrateStorageExplanationStc';
export const ModuleSubmitSectorWideRevenueBusiness = 'submitSectorWideRevenueBusiness';
export const ModuleEstimateSectorWideProject = 'estimateSectorWideProject';
export const ModuleEstimateSectorWideInvest = 'estimateSectorWideInvest';
export const ModuleEstimateSectorWideRegular = 'estimateSectorWideRegular';
export const ModuleHistoryAccess = 'historyAccess';
export const ModuleHistoryPushLog = 'historyPushLog';
export const ModuleGetEstimate = 'getEstimate';
export const ModuleEstimateRegularTemplate = 'estimateRegularTemplate';
export const ModuleBeforeEstimateRegularTemplate = 'beforeEstimateRegularTemplate';

//lập cà cân đối
export const ModuleEstimateArrgrateRegular = 'estimateArrgrateRegular';
export const ModuleEstimateArrgrateExpenseOther = 'estimateArrgrateExpenseOther';
export const ModuleEstimateArrgrateExpenseOtherSTC = 'estimateArrgrateExpenseOtherSTC';
export const ModuleEstimateArrgrateExpenseInvest = 'estimateArrgrateExpenseInvest';
export const ModuleEstimateArrgrateExpenseInvestSTC = 'estimateArrgrateExpenseInvestSTC';
export const ModuleEstimateArrgrateRevenueOther = 'estimateArrgrateRevenueOther';
export const ModuleEstimateArrgrateRevenueOtherSTC = 'estimateArrgrateRevenueOtherSTC';
export const ModuleEstimateArrgrateStorageExplanation = 'estimateArrgrateStorageExplanation';
export const ModuleEstimateArrgrateBudget = 'estimateArrgrateBudget';
export const ModuleEstimateArrgrateExplanationForm = 'EstimateArrgrateExplanationForm';
export const ModuleSummaryEstimateArrgrateRevenueOtherSTC = 'summaryEstimateArrgrateRevenueOtherSTC';
export const ModuleSummaryEstimateArrgrateRevenueBudgetSTC = 'summaryEstimateArrgrateRevenueBudgetSTC';

// nộp stc
export const ModuleSubmitEstimateArrgrateRevenueOtherStc = 'submitEstimateArrgrateRevenueOtherStc';
export const ModuleSubmitEstimateArrgrateRevenueBudgetStc = 'submitEstimateArrgrateRevenueBudgetStc';
export const ModuleSubmitEstimateArrgrateExpenseOtherSTC = 'submitEstimateArrgrateExpenseOtherSTC';

// Lĩnh vực
export const ModuledictionaryField = 'dictionaryField';
export const ModuleEstimateBudget = 'estimateBudget';
export const ModuleEstimateSummary = 'estimateSummary';
export const ModuleSummaryEstimateInitial = 'summaryEstimateInitial';
export const ModuleEstimateSummarySymmetrical = 'estimateSummarySymmetrical';

export const ModuleBeforeExpenseInvest = 'beforeExpenseInvest';
export const ModuleBeforeExpenseInvestByCapital = 'beforeExpenseInvestByCapital';
export const ModuleBeforeExpenseInvestByField = 'beforeExpenseInvestByField';
export const ModuleBeforeExpenseRegular = 'beforeExpenseRegular';
export const ModuleBeforeExpenseProject = 'beforeExpenseProject';
export const ModuleBeforeExpenseFees = 'beforeExpenseFees';
export const ModuleBeforeInvestFees = 'beforeInvestFees';
export const ModuleBeforeSalaryFees = 'beforeSalaryFees';
export const ModuleBeforeExpenseActiveRegular = 'beforeExpenseActiveRegular';
export const ModuleBeforeExpenseActiveInvest = 'beforeExpenseActiveInvest';
export const ModuleBeforeExpenseActiveSalary = 'beforeExpenseActiveSalary';
export const ModuleBeforeExpenseOther = 'beforeExpenseOther';
export const ModuleEstimateInvest = 'estimateInvest';

// Dữ liệu năm trước
export const ModuleBeforeDataRevenueOther = 'beforeDataRevenueOther';
export const ModuleBeforeDataRevenueFees = 'beforeDataRevenueFees';
export const ModuleBeforeDataRevenueBudget = 'beforeDataRevenueBudget';
export const ModuleBeforeDataEstArrgrateBudgetCollection = 'beforeDataEstArrgrateBudgetCollection';
export const ModuleBeforeDataRevenueBusiness = 'beforeDataRevenueBusiness';
export const ModuleBeforeDataCalculationBasis = 'beforeDataCalculationBasis';

// Kiểm tra
export const ModuleExamineListForm = 'examineListForm';
export const ModuleExamineBudget = 'examineBudget';

// Kiểm tra danh sách
export const ModuleExamineList = 'examineList';
export const ModuleExamineThreeYearList = 'examineThreeYearList'; // Lập dự toán 3-5 năm
export const ModuleEstimateThreeYearRevenueFees = 'estimateThreeYearRevenueFee';
export const ModuleEstimateThreeYearExpenseFees = 'estimateThreeYearExpenseFee';
export const ModuleEstimateThreeYearFees = 'estimateThreeYearFee';

// Kiểm tra nhận

export const ModuleAuditReceive = 'auditReceive';
export const ModuleAuditReceiveExpenseBusiness = 'auditReceiveExpenseBusiness';
export const ModuleAuditReceiveExpenseFees = 'auditReceiveExpenseFees';
export const ModuleAuditReceiveExpenseOther = 'auditReceiveExpenseOther';
export const ModuleAuditReceiveExplanationForm = 'auditReceiveExplanationForm';
export const ModuleAuditReceiveFormModelListType = 'auditReceiveFormModelListType';
export const ModuleAuditReceiveInvest = 'auditReceiveInvest';
export const ModuleAuditReceiveProject = 'auditReceiveProject';
export const ModuleAuditReceiveRegular = 'auditReceiveRegular';
export const ModuleAuditReceiveRevenueBudget = 'auditReceiveRevenueBudget';
export const ModuleAuditReceiveRevenueBusiness = 'auditReceiveRevenueBusiness';
export const ModuleAuditReceiveRevenueFees = 'auditReceiveRevenueFees';
export const ModuleAuditReceiveRevenueOther = 'auditReceiveRevenueOther';
export const ModuleAuditReceiveStorageExplanation = 'auditReceiveStorageExplanation';
export const ModuleAuditReceiveRegularExplanation = 'auditReceiveRegularExplanation';
export const ModuleEstimateSubmit = 'estimateSubmit';

// Kiểm tra
export const ModuleAuditEstimateProject = 'auditEstimateProject';
export const ModuleAuditEstimateRevenueFees = 'auditEstimateRevenueFees';
export const ModuleAuditEstimateExpenseFees = 'auditEstimateExpenseFees';
export const ModuleAuditEstimateExpenseBusiness = 'auditEstimateExpenseBusiness';
export const ModuleAuditEstimateExpenseOther = 'auditEstimateExpenseOther';
export const ModuleAuditEstimateInvest = 'auditEstimateInvest';
export const ModuleAuditEstimateRegular = 'auditEstimateRegular';
export const ModuleAuditEstInitialRegular = 'auditEstInitialRegular';
export const ModuleAuditEstimateStorageExplanation = 'auditEstimateStorageExplanation';
export const ModuleAuditEstimateExplanationFormStore = 'auditEstimateExplanationFormStore';
export const ModuleAuditEstimateList = 'auditEstimateList';
export const ModuleAuditArrgrateEstimateList = 'auditArrgrateEstimateList';
export const ModuleAuditEstimateDVCQList = 'auditEstimateDVCQList';
export const ModuleAuditEstimateRevenueOther = 'auditEstimateRevenueOther';
export const ModuleAuditEstimateRevenueBudget = 'auditEstimateRevenueBudget';
export const ModuleAuditEstimateRevenueBusiness = 'auditEstimateRevenueBusiness';
export const ModuleAuditEstimateCalculationBasis = 'auditEstimateCalculationBasis';
export const ModuleAuditEstimateRegularExplanation = 'auditEstimateRegularExplanation';
export const ModuleAuditEstimateCQSNRevenueFees = 'auditEstimateCQSNRevenueFees';
export const ModuleAuditEstimateCQSNExpenseFees = 'auditEstimateCQSNExpenseFees';
export const ModuleAuditEstimateCQSNRevenueBusiness = 'auditEstimateCQSNRevenueBusiness';
export const ModuleAuditEstimateCQSNExpenseBusiness = 'auditEstimateCQSNExpenseBusiness';

// Gửi trả
export const ModuleReturnEstimateRegular = 'returnEstimateRegular';
export const ModuleReturnEstimateCalculationBasis = 'returnEstimateCalculationBasis';
export const ModuleReturnEstimateProject = 'returnEstimateProject';
export const ModuleReturnEstimateExpenseOther = 'returnEstimateExpenseOther';
export const ModuleReturnEstimateInvest = 'returnEstimateInvest';
export const ModuleReturnEstimateRevenueBudget = 'returnEstimateRevenueBudget';
export const ModuleReturnEstimateRevenueBusiness = 'returnEstimateRevenueBusiness';
export const ModuleReturnEstimateExpenseBusiness = 'returnEstimateExpenseBusiness';
export const ModuleReturnEstimateExpenseFees = 'returnEstimateExpenseFees';
export const ModuleReturnEstimateRevenueFees = 'returnEstimateRevenueFees';
export const ModuleReturnEstimateRevenueOther = 'returnEstimateRevenueOther';
export const ModuleReturnEstimateStorageExplanation = 'returnEstimateStorageExplanation';
export const ModuleReturnEstimateExplanationFormStore = 'returnEstimateExplanationFormStore';
export const ModuleReturnEstimateRegularExplanation = 'returnEstimateRegularExplanation';

//Gửi trả ĐVCQ
export const ModuleReturnArrgrateRevenueBusinessStore = 'returnArrgrateRevenueBusinessStore';
export const ModuleReturnArrgrateRevenueFeeStore = 'returnArrgrateRevenueFee';
export const ModuleReturnArrgrateExpenseBusinessStore = 'returnArrgrateExpenseBusinessStore';
export const ModuleReturnArrgrateExpenseFeeStore = 'returnArrgrateExpenseFeeStore';
export const ModuleReturnArrgrateRegularStore = 'returnArrgrateRegularStore';
export const ModuleReturnArrgrateRegularOrgStore = 'returnArrgrateRegularOrgStore';
export const ModuleReturnArrgrateProjectStore = 'returnArrgrateProjectStore';
export const ModuleReturnArrgrateProjectOrgStore = 'returnArrgrateProjectOrgStore';
export const ModuleReturnArrgrateInvestStore = 'returnArrgrateInvestStore';
export const ModuleReturnArrgrateStorageExplanation = 'returnArrgrateStorageExplanation';
export const ModuleReturnArrgrateExplanationFormStore = 'returnArrgrateExplanationFormStore';
export const ModuleReturnArrgrateCalculationBasisStore = 'returnArrgrateCalculationBasisStore';

//  nộp dự toán
export const ModuleEstimateSubmitDetail = 'EstimateSubmitDetail';
export const ModuleApproveDicProject = 'approveDicProject';
export const ModuleApproveDictionary = 'approveDictionary';
export const ModuleReturnApproveDictionary = 'returnApproveDictionary';
export const ModuleReturnSectorWideApproveDictionary = 'returnSectorWideApproveDictionary';
export const ModuleApproveDicRegular = 'approveDicRegular';
export const ModuleEstimateInvestSubmitDetail = 'EstimateInvestSubmitDetail';

export const ModuleApproveDicFees = 'approveDicFees';

export const ModuleOrganizationUnder = 'organizationUnder';
export const ModuleOrganizationGroup = 'organizationGroup';

export const ModuleUserManager = 'userManager';

// Quản lý vai trò
export const ModuleRoleManager = 'roleManager';

// Thông báo
export const ModuleNotification = 'notification';
/**
 * Danh sách module của chương trình
 */

//  Báo cáo
export const ModuleReport = 'Report';

// Tổng hợp cấp trên

export const ModuleSummaryEstimateRevenueBudget = 'summaryEstimateRevenueBudget';
export const ModuleSummaryEstimateRevenueOther = 'summaryEstimateRevenueOther';
export const ModuleSummaryEstimateRegular = 'summaryEstimateRegular';

export const ModuleSubmitSummaryRegularDetailSTC = 'submitSummaryRegularDetailSTC';

export const ModuleSubmitSummaryProjectDetailSTC = 'submitSummaryProjectDetailSTC';

export const ModuleSummaryEstimateFees = 'summaryEstimateFees';
export const ModuleSummaryEstimateCalculateBasis = 'summaryEstimateCalculateBasis';
export const ModuleSummaryEstimateInvestDetail = 'summaryEstimateInvestDetail';
export const ModuleSummaryEstimateOther = 'summaryEstimateOther';
export const ModuleSummaryEstimateProjectExpenseDetail = 'summaryEstimateProjectExpenseDetail';
export const ModuleSummaryEstimateBusiness = 'summaryEstimateBusiness';
export const ModuleSummaryEstimateRegularSummaryExplanation = 'summaryEstimateRegularSummaryExplanation';
// Lập toàn ngành
export const ModuleEstimateSectorWideStorageExplanation = 'estimateSectorWideStorageExplanation';
export const ModuleEstimateSectorWideFees = 'estimateSectorWideFees';
export const ModuleEstimateSectorWideBusiness = 'estimateSectorWideBusiness';
export const ModuleSummaryEstimateArrgrate = 'summaryEstimateArrgrate';
export const ModuleSummaryEstimateSTCArrgrate = 'summaryEstimateArrgrateSTC';

// Kiểm tra cq
export const ModuleAuditEstArrgrateCalculationBasis = 'auditEstArrgrateCalculationBasis';
export const ModuleAuditEstimateArrgrateCalculationBasisPTC = 'auditEstimateArrgrateCalculationBasisPTC';
export const ModuleAuditEstArrgrateProject = 'auditEstArrgrateProject';
export const ModuleAuditEstArrgrateProjectOrg = 'auditEstArrgrateProjectOrg';
export const ModuleAuditEstArrgrateProjectSTC = 'auditEstArrgrateProjectSTC';
export const ModuleAuditEstArrgrateRegular = 'auditEstArrgrateRegular';
export const ModuleAuditEstArrgrateInvest = 'auditEstArrgrateInvest';
export const ModuleAuditEstArrgrateRegularOrg = 'auditEstArrgrateRegularOrg';
export const ModuleAuditEstArrgrateStorageExplanation = 'auditEstArrgrateStorageExplanation';
export const ModuleAuditEstArrgrateExplanationFormStore = 'auditEstArrgrateExplanationFormStore';
export const ModuleAuditRececiveExplanationFormSalary = 'auditReceiveExplanationFormSalaryStore';
export const ModuleReturnExplanationFormSalary = 'returnExplanationFormSalaryStore';
export const ModuleReturnArrgrateExplanationFormSalary = 'returnArrgrateExplanationFormSalaryStore';
export const ModuleReturnArrgrateExplanationFormSalaryOrg = 'returnArrgrateExplanationFormSalaryOrgStore';
export const ModuleAuditEstArrgrateBudgetCollectionOrg = 'auditEstArrgrateBudgetCollectionOrg';
export const ModuleAuditEstArrgrateBudgetCollection = 'auditEstArrgrateBudgetCollection';

// Tổng hợp STC
export const ModuleSummaryEstArgrateRevenueBudget = 'summaryEstArgrateRevenueBudget';
export const ModuleSummaryEstArgrateRevenueOther = 'summaryEstArgrateRevenueOther';
export const ModuleSummaryAuditEstimateSTC = 'summaryAuditEstimateSTC';

// Kiểm tra PTC
export const ModuleAuditEstArrgrateRevenueOther = 'auditEstArrgrateRevenueOther';

// Tổng hợp STC
export const ModuleSummaryEstimateRegularSTCDetail = 'summaryEstimateRegularSTCDetail';
export const ModuleSummaryEstimateCalculateBasisSTCDetail = 'summaryEstimateCalculateBasisSTCDetail';
export const ModuleSummaryEstimateInvestSTCDetail = 'summaryEstimateInvestSTCDetail';
export const ModuleSummaryEstimateInvestCapitalSTCDetail = 'summaryEstimateInvestCapitalSTCDetail';
export const ModuleSummaryEstimateOtherSTCDetail = 'summaryEstimateOtherSTCDetail';
export const ModuleSummaryEstimateProjectExpenseSTCDetail = 'summaryEstimateProjectExpenseSTCDetail';
export const ModuleSummaryEstimateRegularSummaryExplanationSTC = 'summaryEstimateRegularSummaryExplanationSTC';

export const ModuleAuditSummaryRegularDetail = 'auditSummaryRegularDetail';
export const ModuleAuditSummaryProjectDetail = 'auditSummaryProjectDetail';
export const ModuleAuditSummaryExplanationFormStore = 'auditSummaryExplanationForm';

export const ModuleSummaryEstimateExplanationForm = 'summaryEstimateExplanationForm';

export const ModuleSubmitSummaryExplanationForm = 'submitSummaryExplanationForm';
export const ModuleSummaryEstInitialExplanationForm = 'summaryEstInitialExplanationForm';
export const ModuleHelp = 'helpLink';

//dự toán 3 năm
export const ModuleEstimateThreeYearRegular = 'estimateThreeYearRegular';
export const ModuleEstimateFinanceThreeYearRegular = 'estimateFinanceThreeYearRegular';

// Dự toán 3 năm
export const ModuleEstimateThreeYearExpenseInvest = 'estimateThreeYearExpenseInvest';
// 3 năm
export const ModuleAuditReceiveThreeYear = 'auditReceiveThreeYear';
export const ModuleAuditEstArrgrateInvestCapital = 'auditEstArrgrateInvestCapital';

export const ModuleAuditEstCalculationBasis = 'auditEstCalculationBasis';
export const ModuleAuditEstArrgrateInvestSTC = 'auditEstArrgrateInvestSTC';
export const ModuleAuditEstArrgrateRegularSTC = 'auditEstArrgrateRegularSTC';
export const ModuleMisaAva = 'misaAva';
// Dự toán 3 năm ở đơn vị chủ quản
// chi thường xuyên
export const ModuleEstimateArrgrateThreeYearRegular = 'estimateArrgrateThreeYearRegular';
export const ModuleEstimateArrgrateThreeYearProject = 'estimateArrgrateThreeYearProject';
export const ModuleEstimateArrgrateThreeYearInvest = 'estimateArrgrateThreeYearInvest';

export const ModuleSummaryEstimateArrgrateExpenseOtherSTC = 'summaryEstimateArrgrateExpenseOtherSTC';

// Dự toán Vay - Trả nợ
export const ModuleEstimateArrgrateLoanRepayment = 'estimateArrgrateLoanRepayment';

export const ModuleProcessManager = 'processManager'; 

// phân bổ stc
export const ModuleAllocationDecision = 'allocationDecision';
export const ModuleAllocationDecisionDVCQ = 'allocationDecisionDVCQ';
export const ModuleAllocationDecisionHCSNUnderStc = 'allocationDecisionHCSNUnderStc';
export const ModuleAllocationImplement = 'allocationImplement';
export const ExpenseInvestMappingSource = 'expenseInvestMappingSource';

export const ModuleAllocationImplementRegular = 'allocationImplementRegular';
export const ModuleAllocationImplementInvest = 'allocationImplementInvest';
export const ModuleAllocationImplementInvestSTCDistrict = 'allocationImplementInvestSTCDistrict';
export const ModuleAllocationImplementRevenueBudget = 'allocationImplementRevenueBuget';
export const ModuleAllocationImplementSummaryRevenueBudget = 'allocationImplementSummaryRevenueBuget';
export const ModuleAllocationImplementOther = 'allocationImplementOther';
export const ModuleAllocationImplementOtherDistrictSTC = 'allocationImplementOtherDistrictSTC';

export const ModuleAllocationDeliver = 'allocationDeliver';
export const ModuleAllocationDeliverPTC = 'allocationDeliverPTC';
export const ModuleAllocationDeliverSCQ = 'allocationDeliverSCQ';
export const ModuleAllocationAddAdjustDeliverSCQ = 'allocationAddAdjustDeliverSCQ';

// Phân bổ sở chủ quản
export const ModuleAllocationDecisionSCQ = 'allocationReceiveSCQ';
// hướng dẫn sử dụng
export const ModuleGuidUseDictionary = 'guidUseDictionary';

// Kiểm tra danh sách dự toán đầu năm
export const ModuleExamineInitialList = 'examineInitialList';
export const ModuleApproveDictionaryInitial = 'approveDictionaryInitial';
export const ModuleAuditReceiveInitial = 'auditReceiveInitial';
export const ModuleAuditEstInitialRevenueFees = 'auditEstInitialRevenueFees';
export const ModuleAuditEstInitialRevenueBusiness = 'auditEstInitialRevenueBusiness';
export const ModuleReturnApproveDictionaryInitial = 'returnApproveDictionaryInitial';
// Thêm module mới
export const ModuleReportTemplateFileRelation = 'reportTemplateFileRelation';
export const ModuleReportTemplateFileFormular = 'reportTemplateFileFormular';

export const ModuleReportCustomTool = 'reportCustomTool';

//kiểm tra đầu năm
export const ModuleAuditEstInitialStorageExplanation = 'auditEstInitialStorageExplanation';
export const ModuleAuditEstInitialExplanationForm = 'auditEstInitialExplanationForm';
export const ModuleAuditEstInitialRegularExplanation = 'auditEstInitialRegularExplanation';

export const ModuleEstInitialAggregateExplanationFormSalary = 'ModuleEstInitialAggregateExplanationFormSalary';
export const ModuleSummaryEISectorWideExplanationForm = 'moduleSummaryEISectorWideExplanationForm';
export const ModuleAlcDelCheckImpList = 'alcDelCheckImpList';

export const AppModules = [
  ModuleContext,
  ModuleOption,
  ModuleEmployee,
  ModuleReportTemplateFile,
  ModuleReportTemplateFileRelation,
  ModuleReportTemplateFileFormular,
  ModuleLayout,
  ModuleOrganizationUnit,
  ModuleInventoryItem,
  ModuleAccount,
  ModuleBuPlanWithDraw,
  ModuleStock,
  ModuleDbOption,
  ModuleDictionaryChapter,
  ModuleProject,
  DemoTreeModule,
  ModuleExpenseInvest,
  ModuleDictionaryKind,
  ModuleDictionarySource,
  DemoTreeModule,
  ModuleRevenueOther,
  ModuleDictionaryFees,
  ModuleDictionaryBusiness,
  ModuleDictionaryRegular,
  ModuleDictionaryRegularPopup,
  ModuleDictionaryRegularExplanation,
  ModuleBudgetItem,
  ModuleDictionarySection,
  ModuleDictionaryRevenueAgency,
  ModuleDictionaryRevenueBudget,
  ModuleDictionaryRevenueBudgetRate,
  ModuleDictionaryRevenueBudgetAgency,
  CriteriaModule,
  ModuleDictionaryExpenseOther,
  ModuleStorageTemplateExplanationList,
  ModuleDictionaryPatternRegular,
  ModuleDictionaryPatternRegularTemplate,
  ModuleDictionaryPatternRegularSubItem,
  ModuleDictionaryField,
  ModuleBusinessSetting,
  ModuleEstimateCategory,
  ModuleEstimateRevenueFees,
  ModuleEstimateThreeYearRevenueFees,
  ModuleEstimateThreeYearExpenseFees,
  ModuleEstimateThreeYearFees,
  ModuleEstimateRegular,
  ModuleEstimateProject,
  ModuleEstimateProjectSTC,
  ModuleExplanationForm,
  ModuleExplanationFormModel,
  ModuleExplanationFormModelListType,
  ModuleEstimateRegularExplanation,
  ModuleEstimateExplanationFormModelListType,
  ModuleEstimateExplanationForm,
  ModuleDictionaryRevenueBudgetWards,
  ModuleEstimateExpenseOther,
  ModuleHistoryAccess,
  ModuleHistoryPushLog,
  ModuledictionaryField,
  ModuleEstimateRegularTemplate,
  ModuleBeforeExpenseInvest,
  ModuleBeforeExpenseRegular,
  ModuleBeforeExpenseProject,
  ModuleBeforeExpenseFees,
  ModuleBeforeInvestFees,
  ModuleBeforeSalaryFees,
  ModuleBeforeExpenseActiveRegular,
  ModuleBeforeExpenseActiveInvest,
  ModuleBeforeExpenseActiveSalary,
  ModuleBeforeExpenseOther,
  ModuleEstimateBudget,
  ModuleEstimateStorageExplanation,
  ModuleEstimateRegularTemplate,
  ModuleEstimateSummary,
  ModuleEstimateRevenueOther,
  ModuleEstimateRevenueBusiness,
  ModuleEstimateArrgrateThreeYear,
  ModuleEstimateExpenseBusiness,
  ModuleEstimateArrgrateThreeYear,
  ModuleEstimateArrgrateThreeYearRevenueBusiness,
  ModuleEstimateArrgrateThreeYearExpenseBusiness,
  ModuleEstimateArrgrateThreeYearRevenueFees,
  ModuleEstimateArrgrateThreeYearExpenseFees,
  ModuleEnactDictionary,
  ModuleEnactDictionaryHistory,
  ModuleRevenueBudgetEnact,
  ModuleAddRevenueBudgetEnact,
  ModuleRevenueOtherEnact,
  ModuleAddRevenueOtherEnact,
  ModuleExpenseOtherEnact,
  ModuleAddExpenseOtherEnact,
  ModuleRevenueBusinessEnact,
  ModuleAddRevenueBusinessEnact,
  ModuleExpenseProjectEnact,
  ModuleAddExpenseProjectEnact,
  ModuleExpenseRegularEnact,
  ModuleAddExpenseRegularEnact,
  ModuleExpenseInvestEnact,
  ModuleAddExpenseInvestEnact,
  ModuleRevenueFeeEnact,
  ModuleAddRevenueFeeEnact,
  ModuleExplanationFormEnact,
  ModuleAddExplanationFormEnact,
  ModuleCalculationBasisEnact,
  ModuleAddCalculationBasisEnact,
  ModuleAddCalculationBasisEnactByKind,
  ModuleCriteriaEnact,
  ModuleAddCriteriaEnact,
  ModuleChooseOrgEnact,
  ModuleEnactContent,
  ModulePatternEstimateExpenseRegularEnact,
  ModuleExamineListForm,
  ModuleAddCriteriaEnactStore,
  ModuleExamineBudget,
  ModuleAuditReceive,
  ModuleAuditReceiveExpenseBusiness,
  ModuleAuditReceiveExpenseFees,
  ModuleAuditReceiveExpenseOther,
  ModuleAuditReceiveExplanationForm,
  ModuleAuditReceiveFormModelListType,
  ModuleAuditReceiveInvest,
  ModuleAuditReceiveProject,
  ModuleAuditReceiveRegular,
  ModuleAuditReceiveRevenueBudget,
  ModuleAuditReceiveRevenueBusiness,
  ModuleAuditReceiveRevenueFees,
  ModuleAuditReceiveRevenueOther,
  ModuleAuditReceiveStorageExplanation,
  ModuleAuditReceiveRegularExplanation,
  ModuleEstimateSubmit,
  ModuleEstimateSubmitDetail,
  ModuleEstimateInvestSubmitDetail,
  ModuleResultSyncDictionary,
  ModuleSyncDictionaryInvest,
  ModuleSyncDictionaryProject,
  ModuleSyncDictionaryRegular,
  ModuleSyncDictionaryBudget,
  ModuleSyncDictionaryCriteria,
  ModuleSyncDictionaryExpenseOther,
  ModuleSyncDictionaryExplanation,
  ModuleSyncDictionaryCalculationBasis,
  ModuleSyncDictionaryPatternRegular,
  ModuleSyncDictionaryFees,
  ModuleSyncDictionaryRevenueBusiness,
  ModuleSyncDictionaryRevenueOther,
  ModuleApproveDicProject,
  ModuleApproveDictionary,
  ModuleReturnApproveDictionary,
  ModuleReturnSectorWideApproveDictionary,
  ModuleApproveDicRegular,
  ModuleSyncDictionary,
  ModuleApproveDicFees,
  ModuleAuditEstimateProject,
  ModuleAuditEstimateRegular,
  ModuleAuditEstInitialRegular,
  ModuleAuditEstimateExpenseBusiness,
  ModuleAuditEstimateExpenseOther,
  ModuleAuditEstimateStorageExplanation,
  ModuleAuditEstimateExplanationFormStore,
  ModuleAuditEstimateList,
  ModuleAuditEstimateInvest,
  ModuleAuditEstimateRevenueFees,
  ModuleAuditEstimateExpenseFees,
  ModuleAuditEstimateRegularExplanation,
  ModuleExamineList,
  ModuleEstimateArrgrateRegular,
  ModuleEstimateArrgrateRevenueOther,
  ModuleEstimateArrgrateRevenueOtherSTC,
  ModuleReport,
  ModuleInfomation,
  ModuleOrganizationUnder,
  ModuleEstimateArrgrateBudget,
  ModuleOrganizationGroup,
  ModuleEstimateArrgrateExpenseOther,
  ModuleEstimateArrgrateExpenseOtherSTC,
  ModuleSummaryEstimateFees,
  ModuleSummaryEstimateCalculateBasis,
  ModuleEstimateArrgrateStorageExplanation,
  ModuleSummaryEstimateRegular,
  ModuleSummaryEstimateRegularSummaryExplanation,
  ModuleSummaryEstimateInvestDetail,
  ModuleSummaryEstimateOther,
  ModuleEstimateArrgrateExpenseInvest,
  ModuleSummaryEstimateProjectExpenseDetail,
  ModuleNotification,
  ModuleOrganizationUnder,
  ModuleEstimateArrgrateBudget,
  ModuleEstimateSummarySymmetrical,
  ModuleEstimateSectorWideStorageExplanation,
  ModuleEstimateSectorWideRegular,
  ModuleEstimateSectorWideFees,
  ModuleEstimateArrgrateExplanationForm,
  ModuleEstimateSectorWideBusiness,
  ModuleAuditEstArrgrateRegular,
  ModuleAuditEstArrgrateRegularOrg,
  ModuleAuditEstArrgrateStorageExplanation,
  ModuleAuditEstArrgrateExplanationFormStore,
  ModuleAuditEstArrgrateInvest,
  ModuleAuditEstimateCQSNRevenueFees,
  ModuleAuditEstimateCQSNExpenseFees,
  ModuleAuditEstimateCQSNRevenueBusiness,
  ModuleAuditEstimateCQSNExpenseBusiness,
  ModuleExplanationFormView,
  ModuleExplanatoryReport,
  ModuleLayoutSalary,
  ModuleDictionaryStaff,
  ModuleSubmitEstimateExplanationFormSalary,
  ModuleAuditRececiveExplanationFormSalary,
  ModuleReturnExplanationFormSalary,
  ModuleAuditArrgrateEstimateList,
  ModuleAuditEstimateDVCQList,
  ModuleReturnArrgrateExplanationFormSalary,
  ModulePublicReportCustom,
  ModuleEstimateThreeYearExpenseInvest,
  ModuleAuditReceiveThreeYear,
  ModuleSummaryEstimateExplanationForm,
  ModuleReturnArrgrateExplanationFormSalaryOrg,
  ModuleCeilingExpensePublish,
  ModuleExamineThreeYearList,
  ModuleHelp,
  ModuleAuditEstimateArrgrateCalculationBasisPTC,
  ModuleAuditEstCalculationBasis,
  ModuleEstimateThreeYearRegular,
  ModuleAuditEstArrgrateInvestCapital,
  ModuleAuditEstArrgrateInvestSTC,
  ModuleAuditEstArrgrateRegularSTC,
  ModuleAuditEstArrgrateRevenueOther,
  ModuleAuditEstArrgrateBudgetCollectionOrg,
  ModuleAuditEstArrgrateBudgetCollection,
  ModuleSummaryEstimateRegularSTCDetail,
  ModuleSummaryEstimateCalculateBasisSTCDetail,
  ModuleSummaryEstimateInvestSTCDetail,
  ModuleSummaryEstimateInvestCapitalSTCDetail,
  ModuleSummaryEstimateOtherSTCDetail,
  ModuleSummaryEstimateProjectExpenseSTCDetail,
  ModuleSummaryEstimateRegularSummaryExplanationSTC,
  ModuleMisaAva,
  ModuleEstimateArrgrateThreeYearRegular,
  ModuleAuditSummaryRegularDetail,
  ModuleAuditSummaryProjectDetail,
  ModuleEstimateArrgrateThreeYearProject,
  ModuleEstimateArrgrateThreeYearInvest,
  ModuleSummaryEstimateArrgrateExpenseOtherSTC,
  ModuleAuditSummaryExplanationFormStore,
  ModuleEstimateFinanceThreeYearRegular,
  ModuleEstimateFinanceThreeYearExpenseOther,
  ModuleEstimateFinanceThreeYearExpenseInvest,
  ModuleProcessManager,
  ModuleAllocationDecision,
  ModuleAllocationDecisionDVCQ,
  ModuleAllocationDecisionHCSNUnderStc,
  ModuleAllocationImplement,
  ExpenseInvestMappingSource,
  ModuleAllocationImplementRegular,
  ModuleAllocationImplementInvest,
  ModuleAllocationImplementInvestSTCDistrict,
  ModuleUserManager,
  ModuleRoleManager,
  ModuleAllocationImplementRevenueBudget,
  ModuleAllocationImplementSummaryRevenueBudget,
  ModuleAllocationDeliver,
  ModuleAllocationDeliverPTC,
  ModuleAllocationDeliverSCQ,
  ModuleAllocationAddAdjustDeliverSCQ,
  ModuleGuidUseDictionary,
  ModuleExamineInitialList,
  ModuleApproveDictionaryInitial,
  ModuleAuditReceiveInitial,
  ModuleAuditEstInitialRevenueFees,
  ModuleAuditEstInitialRevenueBusiness,
  ModuleReportCustomTool,
  ModuleAuditEstInitialStorageExplanation,
  ModuleAuditEstInitialExplanationForm,
  ModuleAuditEstInitialRegularExplanation,
  ModuleEstInitialAggregateExplanationFormSalary,
  ModuleSummaryEISectorWideExplanationForm,
  ModuleAlcDelCheckImpList
];
